import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';
import { environment } from '../environments/environment';
import { StorageService } from './storage.service';
import { Observable } from 'rxjs';

@Injectable()
export class SocketService {



  private socket = io(environment.WS_URL + environment.NAMESPACE);
  SOCKET_CONNECTED = false;

  constructor() {

  }

  auth(value, data, callback) {
    this.socket.emit(value, data, callback);
  }
  emit(value, data) {
    this.socket.emit(value, data);
  }

  disconnect(){
    this.socket.disconnect();
  }

  listen(value) {
    let observable = new Observable<any>((observer) => {
      this.socket.on(value, (data) => {
        observer.next(data);
      });
    });
    return observable;
  }

}
